import React from 'react'
import { useTranslation } from "react-i18next";

function Validator(props) {
    const { t } = useTranslation();

    //Parametros de entrada.
    const inputParam_IsInValidControl = props.isInValid;

    return (
        <>
            {
                inputParam_IsInValidControl === true &&
                <div className="invalid-textbox">
                    {t('data-lang-msg-required')}
                </div>
            }
        </>
    );
}

export default Validator;

